<template>
  <div>
    <button type="button" style="visibility:hidden;" id="openModal" class="btn btn-primary" data-toggle="modal" data-target="#modalMesaggeContract">
      Launch demo modal
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modalMesaggeContract" tabindex="-1" role="dialog" aria-labelledby="modalMesaggeContractTitle" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalMesaggeContractTitle">GlobalWork dice:</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" id="textMessages">
          </div>
          <div class="modal-footer">
            <button type="button" id="btnCloseModal" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name:'ModalMeesage',
  data(){
    return{

    }
  },
  methods:{

  },

}
</script>

<style>

</style>